<template>
    <div>
        <Panel
            :title="$t('Email Templates')"
            :add-button="canEdit ? $t('Add Email Template') : ''"
            :delete-button="selected.length > 0"
            :page="page"
            :total-rows="totalRows"
            @change="changePage"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="emailtemplates_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Name') }}</th>
                        <th>{{ $t('Share To Child Organisations') }}</th>
                        <th>{{ $t('Subject') }}</th>
                        <th>{{ $t('Message') }}</th>
                        <th v-if="canEdit"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="template in items" @click="(evt) => handleOpen(template.templateId, evt)">
                        <td class="primary">
                            {{ template.name }}
                        </td>
                        <td><cic-checkbox :enabled="false" :value="template.share" /></td>
                        <td>
                            {{
                                template.subject.length > 50
                                    ? template.subject.substring(0, 50) + '...'
                                    : template.subject
                            }}
                        </td>
                        <td>
                            {{
                                template.message.length > 50
                                    ? template.message.substring(0, 50) + '...'
                                    : template.message
                            }}
                        </td>
                        <td v-if="canEdit" class="td-checkbox">
                            <cic-checkbox
                                v-if="canEditDetails(template.orgId)"
                                :value="selected.includes(template.templateId)"
                                @click="handleSelected(template.templateId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <edit-transmit-template
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditTransmitTemplate from './EditTransmitTemplate';

    export default {
        name: 'TransmitTemplates',
        components: {
            CicCheckbox,
            EditTransmitTemplate,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                page: 1,
                selected: [],
                totalRows: 0,
            };
        },
        computed: {
            canEdit() {
                return this.$store.hasRight('EDIT_TRANSMIT_TEMPLATES');
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            canEditDetails(orgId) {
                return orgId === this.$store.user.orgId;
            },

            handleDelete() {
                deleteItems('transmit/templates/delete', { templateIds: this.selected }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },

            loadTable() {
                this.closePopup();
                load('transmit/templates/get', { page: this.page }, (response) => {
                    this.items = response.templates;
                    this.totalRows = response.totalRows;
                });
            },

            openForm(templateId) {
                if (templateId > 0) {
                    this.item = this.items.find((x) => x.templateId === templateId);
                } else {
                    this.item = {
                        templateId: null,
                        orgId: this.$store.user.orgId,
                        share: false,
                        name: '',
                        subject: '',
                        message: '',
                    };
                }
            },

            saveItem() {
                save('transmit/template/update', { data: JSON.stringify(this.item) }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },
        },
    };
</script>
